// // src/Components/CountdownTimer.jsx
// import React, { useState, useEffect } from "react";

// const CountdownTimer = ({ dueDate, status }) => {
//   const [timeLeft, setTimeLeft] = useState({});

//   useEffect(() => {
//     if (!dueDate || status.toLowerCase() === "completed") return;

//     const timer = setInterval(() => {
//       const target = new Date(dueDate).getTime();
//       const now = new Date().getTime();
//       const difference = target - now;

//       if (difference <= 0) {
//         clearInterval(timer);
//         setTimeLeft(null);
//       } else {
//         setTimeLeft({
//           days: Math.floor(difference / (1000 * 60 * 60 * 24)),
//           hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
//           minutes: Math.floor((difference / (1000 * 60)) % 60),
//           seconds: Math.floor((difference / 1000) % 60),
//         });
//       }
//     }, 1000);

//     return () => clearInterval(timer);
//   }, [dueDate, status]);

//   if (status?.toLowerCase() === "completed") {
//     return <span style={{ fontSize: "13px", color: "#6c757d" }}>Completed</span>;
//   }
//   if (!timeLeft) {
//     return <span style={{ fontSize: "13px", color: "#e74c3c", fontWeight: "600" }}>Expired</span>;
//   }

//   // Determine urgency color
//   const totalHoursLeft = timeLeft.days * 24 + timeLeft.hours;
//   let countdownColor = "#4361ee"; // default color
//   if (totalHoursLeft < 6) countdownColor = "#e74c3c"; // urgent
//   else if (totalHoursLeft < 24) countdownColor = "#f39c12"; // warning

//   return (
//     <div style={{ fontSize: "13px", fontWeight: "600", color: countdownColor }}>
//       {timeLeft.days > 0 && `${timeLeft.days}d `}
//       {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
//     </div>
//   );
// };

// export default CountdownTimer;




// src/Components/CountdownTimer.jsx
import React, { useState, useEffect } from "react";

const CountdownTimer = ({ dueDate, status }) => {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    // If no dueDate or status is completed, don't run timer
    if (!dueDate || status?.toLowerCase() === "completed") return;

    const target = new Date(dueDate).getTime();

    const updateTimer = () => {
      const now = new Date().getTime();
      const difference = target - now;

      if (difference <= 0) {
        setTimeLeft(null); // means "Expired"
      } else {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / (1000 * 60)) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    // Initialize once
    updateTimer();
    // Update every second
    const timer = setInterval(updateTimer, 1000);

    // Cleanup on unmount
    return () => clearInterval(timer);
  }, [dueDate, status]);

  if (status?.toLowerCase() === 'in-progress') {
    return (
      <div style={{ color: '#28a745', fontWeight: '600', fontSize: '12px' }}>
        Work Started
      </div>
    );
  }

  // If order is completed
  if (status?.toLowerCase() === "completed") {
    return <span style={{ fontSize: "13px", color: "#6c757d" }}>Completed</span>;
  }

  // If timeLeft is null => timer has expired
  if (!timeLeft) {
    return (
      <span style={{ fontSize: "13px", color: "#e74c3c", fontWeight: "600" }}>
        Expired
      </span>
    );
  }

  // Destructure remaining time
  const { days, hours, minutes, seconds } = timeLeft;

  // Determine how many total hours are left to decide coloring
  const totalHoursLeft = days * 24 + hours;
  let boxBackground = "#ebf2ff";
  let textColor = "#4361ee";

  if (totalHoursLeft < 6) {
    // Urgent
    boxBackground = "#fdecea";
    textColor = "#e74c3c";
  } else if (totalHoursLeft < 24) {
    // Warning
    boxBackground = "#fff5e6";
    textColor = "#f39c12";
  }

  // --- Styles ---
  const containerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const boxStyle = {
    minWidth: "35px",
    minHeight: "35px",
    backgroundColor: boxBackground,
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "2px",
  };

  const numberStyle = {
    // fontSize: "14px",
    fontSize: "var(--ct-number-font, 14px)",
    fontWeight: "600",
    color: textColor,
    margin: 0,
  };

  const labelStyle = {
    // fontSize: "9px",
    fontSize: "var(--ct-label-font, 9px)",
    color: "#6c757d",
    margin: 0,
  };

  const colonStyle = {
    // fontSize: "16px",
    fontSize: "var(--ct-colon-font, 16px)", 
    fontWeight: "600",
    color: textColor,
    margin: "0 4px",
  };

  // Helper to format single-digit numbers with a leading zero
  const formatNumber = (num) => (num < 10 ? `0${num}` : num);

  return (
    <div style={containerStyle}>
      {/* Days */}
      <div style={boxStyle}>
        <p style={numberStyle}>{formatNumber(days)}</p>
        <p style={labelStyle}>Days</p>
      </div>
      <span style={colonStyle}>:</span>

      {/* Hours */}
      <div style={boxStyle}>
        <p style={numberStyle}>{formatNumber(hours)}</p>
        <p style={labelStyle}>Hrs</p>
      </div>
      <span style={colonStyle}>:</span>

      {/* Minutes */}
      <div style={boxStyle}>
        <p style={numberStyle}>{formatNumber(minutes)}</p>
        <p style={labelStyle}>Min</p>
      </div>
      <span style={colonStyle}>:</span>

      {/* Seconds */}
      <div style={boxStyle}>
        <p style={numberStyle}>{formatNumber(seconds)}</p>
        <p style={labelStyle}>Sec</p>
      </div>
    </div>
  );
};

export default CountdownTimer;
